<template>
  <ModalBase show-modal auto-h width-ms @close-modal="close" class="communication-detail-modal">
    <template v-slot:titlebar>
      <TitleBar variant-class="title-modal title-modal--simple">
        <template v-slot:title>
          <div class="compose-titlewrap">
            <div class="compose-titlewrap--title">
              {{ $gettext('Communication details') }}
            </div>
          </div>
        </template>
      </TitleBar>
    </template>
    <template v-slot:maincontent>

      <div class="communication-detail--top">
        <div style="display: flex; gap: 1rem; justify-content: space-between;">
          <div class="item">
            <div class="label">
              {{ $gettext('Scheduled at') }}
            </div>
            <div class="value">
              {{ communication.scheduled_at | formatDateWithTime }}
            </div>
          </div>
          <div class="item" v-if="new Date(communication.scheduled_at) > new Date() && communication.status === 'idle'">
            <GekkoButton
              @click="editHandler"
              class="text-info"
              variant="link"
              icon="fa-solid fa-pencil"
              :text="$gettext('Edit details')"
              size="sm"
            />
          </div>
        </div>
        

        <div class="item">
          <div class="label">
            {{ $gettext('Recipients') }}
          </div>

          <div class="value recipient-list">
            <div v-if="communication.recipients.length === 0">
              {{ $gettext('All your clients at the scheduled send time.') }}
            </div>
            <div
              v-for="recipient in communication.recipients"
              :key="recipient.id"
              class="recipient-element"
            >
              <span>{{ recipient.name }}</span>
            </div>
      
          </div>
        </div>
      </div>

      <div class="communication-detail--bottom">
          <div class="item">
            <div class="label">
              {{ $gettext('Subject') }}
            </div>
            <div class="">
              {{ communication.subject }}
            </div>
          </div>

          <div class="item">
            <div class="label">
              {{ $gettext('Message') }}
            </div>
            <div class="">
              {{ communication.message }}
            </div>
          </div>

          <div v-if="communication.log" class="item">
            <div class="label">
              {{ $gettext('Message log') }}
            </div>

            <div class="content">
              <b-table
                :items="communication.log"
                :fields="[
                  { key: 'recipient', tdClass: '' },
                  { key: 'status', tdClass: '' },
                  { key: 'created', tdClass: '' },
                ]"
                striped
                show-empty
                thead-class="d-none"
                :class="['ttable gk-table gk-table--responsive gk-table--striped']"
              >
                <template #empty="">
                  <span class="empty-table-text" v-translate
                    >No attempts to send this message have been performed yet.</span
                  >
                </template>

                <template #cell(recipient)="data">
                  <div class="">
                    {{ data.value.name }}
                  </div>
                </template>

                <template #cell(status)="data">
                  <div v-if="data.value === 'sent'" class="status-badge status-complete">
                    {{ $gettext('Sent') }}
                  </div>
                  <div v-else-if="data.value === 'failed'" class="status-badge status-overdue">
                    {{ $gettext('Failed') }}
                  </div>
                </template>

                <template #cell(created)="data">
                  <div class="">
                    {{ data.value | formatDateWithTime }}
                  </div>
                </template>
              </b-table>
            </div>
          </div>
      </div>
    </template>
  </ModalBase>
</template>

<script>
import { defineComponent } from 'vue'
import ModalBase from '@/components/base_components/ModalBase.vue'
import TitleBar from '@/components/TitleBar.vue'
import GekkoButton from '@/components/GekkoButton'

export default defineComponent({
  name: 'CommunicationDetailModal',
  components: { TitleBar, ModalBase, GekkoButton },
  props: {
    communication: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {}
  },
  created() {
    console.log(this.communication)
  },
  methods: {
    close() {
      this.$router.push({
        name: 'Communication',
      })
    },
    editHandler() {
      this.$router.push({ name: 'CommunicationEdit', params: { communication_id: this.communication.id } })
    },
  },
})
</script>

<style lang="scss">
.communication-detail-modal {
  .gk-modal {
    padding: 0rem;
    .gk-modal-content {
      display: block;
      .close-btn {
        top: 6px;
        right: 4px;
        background: transparent !important;
        color: #041e49 !important;
        &:hover {
          background: transparent !important;
        }
      }
    }
  }
  .titlebar.title-modal--simple {
    position: relative !important;
    margin-bottom: 0px !important;
    padding: 0 1rem !important;
    background: #f2f6fc !important;
    border: none !important;
    h2 {
      font-size: 16px !important;
      color: #041e49 !important;
      font-family: $fontRegular !important;
      width: calc(100% - 1.5rem) !important;
    }
    .title-wrap {
      min-height: 40px !important;
    }
    .title-wrap,
    .pagetitle,
    .pagetitle--main {
      width: 100%;
    }
    .compose-titlewrap {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 1rem;
      &--title {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        max-width: 95%;
      }
    }
    .titlebar-maximize {
      cursor: pointer;
    }
  }
  .modal-content-wrap {
    height: calc(100% - 40px);
    min-height: 500px;
    padding: 1rem;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    &:not(.has-actions) {
      border-radius: 0px 0px $radiusLg $radiusLg;
    }
  }

  .communication-detail--top {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
  .communication-detail--bottom {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
  .item {
    display: flex;
    flex-direction: column;
    font-size: 14px;
    .label {
      font-size: 14px;
      color: $colorTextSemi;
    }
    .value {
      font-size: 14px;
      display: flex;
    }
  }
  .recipient-list {
    gap: 0.5rem;
    .recipient-element {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      background: white;
      border-radius: $radiusXl;
      font-size: 14px;
      box-shadow: $emailInputItemShadow;
      padding: 0;
      align-items: center;
      gap: 0.5rem;
      padding: 0.25rem 0.5rem;
      &.is-selected {
        background: #c2e7ff;
        box-shadow: $emailInputItemSelectedShadow;
      }
    }
  }

}
</style>